export default class Fonts {
  static list() {
    return [
      { name: "Avenir", font: "Avenir, sans-serif"},
      { name: "Arial", font: "Arial, sans-serif"},
      { name: "Helvetica", font: "Helvetica, Arial, sans-serif"},
      { name: "Tahoma", font: "Tahoma, sans-serif"},
      { name: "Open Sans", font: "Open Sans, sans-serif", provider: 'Open+Sans:400,700:latin,cyrillic'},
      { name: "Roboto", font: "Roboto, Tahoma, sans-serif", provider: 'Roboto:400,700:latin,cyrillic', loaded: true },
      { name: "Ubuntu", font: "Ubuntu, sans-serif", provider: 'Ubuntu:400,700:latin,cyrillic'},
      { name: "PT Sans", font: "PT Sans, Trebuchet MS, sans-serif", provider: 'PT+Sans:400,700:latin,cyrillic'},
      { name: "Trebuchet MS", font: "Trebuchet MS, sans-serif"},
      { name: "Georgia", font: "Georgia, serif"},
      { name: "PT Serif", font: "PT Serif, Georgia, serif", provider: 'PT+Serif:400,700:latin,cyrillic'}
    ];
  }

  static load() {
    const families = [];
    Fonts.list().forEach(font => {
      if(font.provider && !font.loaded) families.push(font.provider);
    });
    WebFont.load({ google: { families: families }})
  }
}
